export const SELECT_ACCOUNT_TYPE = 'SELECT_ACCOUNT_TYPE';
export const SELECT_TAB_ORDER = 'SELECT_TAB_ORDER';
export const SELECT_PERIOD = 'SELECT_PERIOD';
export const SELECT_PERCENTAGE = 'SELECT_PERCENTAGE';

export const SET_AUTO_ORDER_DATE = 'SET_AUTO_ORDER_DATE';
export const SET_AUTO_PRICE_CONDITION = 'SET_AUTO_PRICE_CONDITION';

export const RESET_POPUP = 'RESET_POPUP';

export const INITIAL_STATE = {
  autoEndDate: new Date(),
  autoStartDate: new Date(),
  autoPriceCondition: 0,
  selectedAccountType: '',
  selectedPercentage: 0,
  selectedPeriod: 'day',
  tabOrder: 'limit',
};

export default (state, action) => {
  const { type, payload = null } = action;

  switch (type) {
    case SELECT_ACCOUNT_TYPE:
      return { ...state, selectedAccountType: payload };
    case SELECT_PERCENTAGE:
      return { ...state, selectedPercentage: payload };
    case SELECT_PERIOD:
      return { ...state, selectedPeriod: payload };
    case SELECT_TAB_ORDER:
      return { ...state, tabOrder: payload };
    case SET_AUTO_ORDER_DATE:
      return {
        ...state,
        autoStartDate: payload.startDate || state.autoStartDate,
        autoEndDate: payload.endDate || state.autoEndDate,
      };
    case SET_AUTO_PRICE_CONDITION:
      return { ...state, autoPriceCondition: payload };
    case RESET_POPUP:
    default:
      return { ...INITIAL_STATE, selectedAccountType: state.selectedAccountType };
  }
};
